import { render, staticRenderFns } from "./EquityAmountDetail.vue?vue&type=template&id=792ae264"
import script from "./EquityAmountDetail.vue?vue&type=script&lang=js"
export * from "./EquityAmountDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports